import parse, { type HTMLReactParserOptions } from 'html-react-parser';
import DOMPurify from 'dompurify';

function replaceNode() {}

function replaceNewlineWithBr(input: string) {
  return input.replace(/\n/g, '<br/>');
}

function replaceNbsps(input: string) {
  return input.replace(/&nbsp;|&#160;/g, ' ');
}

export function cleanHtmlString(htmlString: string) {
  return DOMPurify.sanitize(replaceNewlineWithBr(replaceNbsps(htmlString)), {
    ALLOWED_TAGS: [
      'div',
      'p',
      'strong',
      'em',
      'br',
      'span',
      'ol',
      'ul',
      'li',
      'a',
    ],
    ALLOWED_ATTR: ['style', 'href'],
  });
}

export default function safeParseHtml(
  html: string,
  options: HTMLReactParserOptions = {}
) {
  return parse(cleanHtmlString(html), {
    ...{
      replace: replaceNode,
    },
    ...options,
  });
}
